import CouponCodeTable from './CouponCodeTable'

export default CouponCodeTable
